/**
 * @function SwalToast
 * @description Displays a toast using the Snackbar component from the Material-UI library.
 * @param {object} props - The props object.
 * @param {string} [props.icon='success'] - The type of the toast icon. Defaults to 'success'.
 * @param {string} props.title - The title of the toast.
 * @returns {void}
 */
const SwalToast = ({ icon: type = 'success', title }) => {
  window.enqueueSnackbar(title, { variant: type, preventDuplicate: true });
};

export default SwalToast;
